/** «Жёсткое» обновление портала: чистит Cache API / service worker и
 * перезагружает страницу с кэш-бастером, чтобы вебвью ТСД гарантированно
 * подтянул свежую сборку (заголовки no-store уже стоят на JS/CSS/HTML, но
 * некоторые вебвью кешируют агрессивно). Общая для кнопки «обновить» в меню
 * (`components/BuildVersion.tsx`) и плашки новой версии
 * (`components/UpdateBanner.tsx`). */
export async function hardReload(): Promise<void> {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (err) {
    // Чистка кеша — подстраховка, перезагрузка важнее её; сбой виден в консоли.
    console.warn("hardReload: не удалось очистить кеш", err);
  }
  // Кэш-бастер в query, чтобы вебвью гарантированно перезапросил index.html.
  const url = new URL(window.location.href);
  url.searchParams.set("_v", Date.now().toString());
  window.location.replace(url.toString());
}
